/*import axios from "axios";

let authApi = axios.create({
  baseURL: "https://api.mobiezy.in",
  headers: {
    "x-api-key": "aMqwyQJdA1aqH5GkpG5NR78UyswcHhkEaMZCfrC8",
    "Content-Type": "application/json",
  },
});

let authApi1 = axios.create({
  // baseURL: "https://91z8byyrzi.execute-api.ap-south-1.amazonaws.com",
  headers: {
    "x-api-key": "ffWim00xLx52kC5AI8xJk5B1tSBrRnyH3TqOv8Y5",
    "Content-Type": "application/json",
  },
});

// eslint-disable-next-line import/no-anonymous-default-export
export default {



  getComplaints(value) {
    return authApi.post("/mpay/mpay_getCustomerComplaints", value);
  },

  addComplaintsrupee(value) {
    return authApi.post("/mpay/rupayee_manageComplaintsNew", value);
  },
  addComplaints(value) {
    return authApi.post("/prod/manageComplaint", value);
  },


//-----------------------------------------

newlogin(value){
  return authApi1.post(
    "https://api.mobiezy.in/mpay/Mobiezyb2c_V3_getPhoneNumbersList",
    value
  );
},

custDetails(value){
  return authApi1.post(
    "https://api.mobiezy.in/mpay/mpayReact_v3_getCustInfoDetails_prc",
    value
  );
},


cashfree_init(value) {
  return authApi.post(
    "https://api.mobiezy.in/mpay/generate_token_link_payment",
    value
  );
},

  getTranHistoryCashfree(value) {
    return authApi1.post(
      "https://api.mobiezy.in/mpay/mobiezy_v3_getCustomerPaymentHistory",
      value
    );
  },
};
*/

import axios from "axios";

let authApi = axios.create({
  baseURL: "https://api.mobiezy.in",
  headers: {
    "x-api-key": "aMqwyQJdA1aqH5GkpG5NR78UyswcHhkEaMZCfrC8",
    "Content-Type": "application/json",
  },
});

let authApi1 = axios.create({
  // baseURL: "https://91z8byyrzi.execute-api.ap-south-1.amazonaws.com",
  headers: {
    "x-api-key": "ffWim00xLx52kC5AI8xJk5B1tSBrRnyH3TqOv8Y5",
    "Content-Type": "application/json",
  },
});

// eslint-disable-next-line import/no-anonymous-default-export
export default {



  getComplaints(value) {
    return authApi.post("/mpay/mpay_getCustomerComplaints", value);
  },

  addComplaintsrupee(value) {
    return authApi.post("/mpay/rupayee_manageComplaintsNew", value);
  },
  addComplaints(value) {
    return authApi.post("/mpay/mobiezyb2c_v3_manageComplaint_prc", value);
  },


//-----------------------------------------

newlogin(value){
  return authApi1.post(
    "https://api.mobiezy.in/mpay/Mobiezyb2c_V3_getPhoneNumbersList",
    value
  );
},

custDetails(value){
  return authApi1.post(
    "https://api.mobiezy.in/mpay/mpayReact_v3_getCustInfoDetails_prc",
    value
  );
},


cashfree_init(value) {
  return authApi.post(
    "https://api.mobiezy.in/mpay/generate_token_link_payment",
    value
  );
},

  getTranHistoryCashfree(value) {
    return authApi1.post(
      "https://api.mobiezy.in/mpay/mobiezy_v3_getCustomerPaymentHistory",
      value
    );
  },
};
